import { render, staticRenderFns } from "./EditInspector.vue?vue&type=template&id=387d8590"
import script from "./EditInspector.vue?vue&type=script&lang=js"
export * from "./EditInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports